const DataProtection = () => {
  return (
    <div className="w-full p-6">
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <h1 className="text-2xl font-bold text-gray-900 uppercase">
          Data Protection
        </h1>
        <p>
          <strong>Helacred</strong> is committed to protecting the
          privacy of its members. We collect and use relevant personal
          information to provide you with the credit facility, manage your loan
          account, and meet our legal and regulatory obligations.
        </p>
        <p>
          By consenting to this statement, you agree that we may collect and
          process information about you from internal records and third parties
          (e.g., credit reference bureaus) where applicable. You also consent
          that your personal information, including your loan performance data,
          may be disclosed to our partners, guarantors, and relevant third
          parties for the purposes of safeguarding the interests of{" "}
          <strong>Helacred</strong> and to facilitate the proper
          management of your loan.
        </p>
        <p>
          This consent allows <strong>Helacred</strong> to proceed with
          and obtain any such information from or about you for the purposes of
          managing your loan facility.
        </p>
        <h2 className="text-xl font-semibold text-gray-900">
          Personal Data Collection and Processing
        </h2>
        <p>
          We will collect, use, store, share, or otherwise process personal data
          about you (or persons connected to you), including:
        </p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Your name</li>
          <li>Date of birth</li>
          <li>
            Contact details such as your email address, physical address, and
            telephone number
          </li>
          <li>
            Any other information required for the purpose of providing
            financial services to you
          </li>
        </ul>
        <p>
          Communication to contacts via short message services (SMS) may also be
          used. We will retain your personal data for as long as necessary to
          fulfill the purposes outlined in this form, or as required by law.
        </p>
        <p>
          You have the right to withdraw your consent at any time by contacting
          us at{" "}
          <a
            href="mailto:customer@helacred.com"
            className="text-blue-600 underline"
          >
            customer@helacred.com
          </a>
          . However, the withdrawal of consent shall not affect the lawfulness
          of processing based on prior consent before its withdrawal. Please
          note that withdrawing consent may also affect our ability to provide
          certain services or fulfill obligations, and may also expose you to
          liability for any services rendered prior to such withdrawal.
        </p>
        <p>
          The processing of personal data is exempt from the provisions of the
          Act if it is necessary for national security, or its disclosure is
          required under any written law, an order of the court, or for the
          prevention or detection of a crime.
        </p>
        <h2 className="text-xl font-semibold text-gray-900">
          Acknowledgment and Acceptance of the Terms and Conditions
        </h2>
        <div className="mt-6 space-y-6">
          <div>
            <h3 className="font-semibold">For the Borrower</h3>
            <p>
              I,{" "}
              <span className="font-semibold">[Borrower&#39;s Full Name]</span>,
              of National ID No.{" "}
              <span className="font-semibold">[ID Number]</span>, have read and
              understood the full loan terms and conditions and hereby agree to
              be bound by them.
            </p>
            <p>
              <strong>Signature:</strong> _________________________
            </p>
            <p>
              <strong>Date:</strong> _________________________
            </p>
          </div>

          <div>
            <h3 className="font-semibold">For the Guarantor</h3>
            <p>
              I,{" "}
              <span className="font-semibold">[Guarantor&#39;s Full Name]</span>
              , of National ID No.{" "}
              <span className="font-semibold">[ID Number]</span>, have read and
              understood the full loan terms and conditions. I acknowledge that
              in case of default by the primary borrower, I shall act as a
              surety and will be held equally responsible for repaying the loan
              as though I were the borrower.
            </p>
            <p>By signing below, I agree to be bound by these terms.</p>
            <p>
              <strong>Guarantor&#39;s Signature:</strong>{" "}
              _________________________
            </p>
            <p>
              <strong>Date:</strong> _________________________
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataProtection;
